import { CardActions, CardContent, Collapse, Divider, styled, Typography } from "@mui/material";
import { IPairExtended } from "../PairSpreadItem/PairSpreadItem";
import IconButton from '@mui/material/IconButton';
import { useState, useEffect } from "react";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { trueDaysForm } from "../../utils/true.word.form";
import { unixToShortString } from "../../utils/time";

export const StrategyBlock: React.FC<IPairExtended> = (pairData: IPairExtended) => { 
    const [expanded, setExpanded] = useState(true);
    const [statusIcon, setStatusIcon] = useState('❓');

    useEffect(() => {
        switch (pairData?.dividend?.status) {
            case 'declared': setStatusIcon('📢'); break;
            case 'forecast': setStatusIcon('📈'); break;
            case 'approved': setStatusIcon('☑️'); break;
            
            case 'unknown':
            default:
                setStatusIcon('❓'); break;
        }
    }, [pairData?.dividend?.status]);

    const ExpandMore = styled((props: any) => {
        const { expand, ...other } = props;
            return <IconButton {...other} />;
        })(({ theme, expand }) => ({
            transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
            marginLeft: 'auto',
            marginTop: 0,
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shortest,
            }),
    }));

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const strategyStatus = () => pairData?.dividend && pairData?.dividend.status !== 'unknown' && pairData?.strategy;

    const noDividends = () => {
        return (
            <Typography variant="body2" color="text.secondary">
                <div className='infoCaption'>
                    { `⚠️ Стратегия недоступна` }
                </div>
            </Typography>
        );
    }

    const strategyData = () => {
        return (
            <>
                <CardActions disableSpacing className='expandCont'>
                    <span className='expandTitle'>{ `${statusIcon} Стратегия ${pairData.strategy?.actualFuture?.shortName} (${pairData.strategy?.actualFuture?.code})` }</span>
                    <ExpandMore
                        expand={ expanded }
                        onClick={ handleExpandClick }
                        aria-expanded={ expanded }
                        aria-label="Подробнее"
                    >
                        <ExpandMoreIcon />
                    </ExpandMore>
                </CardActions>

                <Collapse in={expanded} timeout="auto" unmountOnExit>
                    <CardContent className='cardContent'>
                        <div className='container'>
                            { `Цена 1 фьючерса` }
                            {<span className='price'>{`${(pairData.strategy.oneFuturePrice)?.toFixed(2)} руб.`}</span>}
                        </div>

                        <div className='container'>
                            { `ГО за 1 фьючерс` }
                            <div>
                                <div className='price'>{`${(pairData.strategy.oneFutureInitialMargin)?.toFixed(2)} руб.`}</div>
                                <div className='smallPrice'>{`${(pairData.strategy.actualFuture?.initialMarginPercent)?.toFixed(2)}%`}</div>
                            </div>
                        </div>
                        <div className='container'>
                            { `Справедливая цена` }
                            <span className='price'>{`${(pairData.strategy.fairPrice)?.toFixed(2)} руб.`}</span>
                        </div>
                        <div className='container'>
                            { `30 дней` }
                            <span className='price'>{`${(pairData.strategy.days30)?.toFixed(2)}`}</span>
                        </div>
                        <div className='container'>
                            { `Экспирация` }
                            <div>
                                <div className='price'>{unixToShortString(pairData.strategy.actualFuture.deliveryDate)}</div>
                                <div className='smallPrice'>{`${(pairData.strategy.daysCountToExpiration)?.toFixed(2)} ${trueDaysForm(pairData.strategy.daysCountToExpiration)}`}</div>
                            </div>
                        </div>

                        <Divider sx={{ mt: '5pt', mb: '5pt' }} />
   
                        <div className='container'>
                            { `Див. доходность` }
                            <div>
                                <div className='price'>{`${(pairData.dividend?.value / pairData.base.price?.ask! * 100).toFixed(2)}%`}</div>
                                <div className='smallPrice'>{`${(pairData.dividend?.value).toFixed(2)} руб.`}</div>
                            </div>
                        </div>
                        <div className='container'>
                            { `Див. отсечка` }
                            <div>
                                <div className='price'>{unixToShortString(pairData.dividend.closeDate)}</div>
                                <div className='smallPrice'>{`${(pairData.strategy.daysCountToDividendCutOff)?.toFixed(2)} ${trueDaysForm(pairData.strategy.daysCountToDividendCutOff)}`}</div>
                            </div>
                        </div>
                        <div className='container'>
                            { `Дельта` }
                            <span className='price'>{`${(pairData.strategy.delta * 100).toFixed(2)}%`}</span>
                        </div>
                        <div className='container'>
                            { `Макс. доход` }
                            <span className='price'>{`${(pairData.strategy.maxProfitRate * 100).toFixed(2)}%`}</span>
                        </div>
                        <div className='container'>
                            { `Доходность на дату див. отсечки` }
                            <span className='price'>{`${(pairData.strategy.dividendCutOffProfitRate * 100).toFixed(2)}%`}</span>
                        </div>
                        <div className='container'>
                            { `Доходность на дату экспирации` }
                            <span className='price'>{`${(pairData.strategy.expirationProfitRate * 100).toFixed(2)}%`}</span>
                        </div>

                        <Divider sx={{ mt: '5pt', mb: '5pt' }} />

                        <div className='container'>
                            { `Источник` }
                            <div>
                                <div className='price'>{pairData.dividend?.source}</div>
                            </div>
                        </div> 
                    </CardContent>
                </Collapse>
            </>
        );
    }

    return (
        <>
            { strategyStatus() ? strategyData() : noDividends() }
        </>
    );
}